import { SHOPIFY_DOMAIN } from './constants';

export const getShopifyAxiosConfig = (
  token: string,
): {
  headers: {
    'X-Shopify-Storefront-Access-Token': string;
  };
} => ({
  headers: { 'X-Shopify-Storefront-Access-Token': token },
});

export const getShopifyFetchConfig = (
  token: string,
): {
  headers: {
    'X-Shopify-Storefront-Access-Token': string;
    'Content-Type': 'application/json';
  };
} => ({
  headers: {
    'X-Shopify-Storefront-Access-Token': token,
    'Content-Type': 'application/json',
  },
});

export const getShopifyUrlAndToken = (): { shop: string; token: string } => ({
  shop: SHOPIFY_DOMAIN,
  token: process.env.GATSBY_SHOPIFY_STOREFRONT_TOKEN,
});

export const getShopifyGqlEndpoint = (): string =>
  `https://${SHOPIFY_DOMAIN}/api/2024-07/graphql.json`;
